//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getDetail(key){
    return _axios({
        url: `/api/MaterialReceive/getDetail?supplyId=${key}`,
        method: 'get'
    })
}

export function submit(data){
    return _axios({
        url: `/api/MaterialReceive/submit`,
        method: 'post',
        data:data
    })
}
